const t = {
  name: "ChevronLeftSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.4144 8.00015L11.4144 12.0002L15.4144 16.0002L14.0002 17.4144L8.58594 12.0002L14.0002 6.58594L15.4144 8.00015Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ChevronLeftSmall
};
